import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { IIssueStateWorkflow } from "@common/interfaces/issueStateWorkflow";
import { Topics } from "@common/interfaces/topics";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface IssueStateWorkflowState extends EntityState<IIssueStateWorkflow, ID> { }

@Injectable({
    providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ISSUE_STATE_WORKFLOWS , realtimeEntity: 'IssueStateWorkflow'})
export class IssueStateWorkflowStore extends EntityStore<IssueStateWorkflowState> {
    constructor() {
        super([]);
    }
}
